import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpJobs'

// Requests from professionals to have their listing posted on MG's own
// LinkedIn and @mundogamer.jobs.
//
// Nothing publishes automatically: LinkedIn needs w_organization_social and
// Instagram needs instagram_content_publish plus a Business account linked to
// a Page, and neither app exists yet. So this screen IS the driver — approve,
// post by hand, paste the URL back. When the credentials land, an automated
// publisher calls the same `published` endpoint and nothing else changes.
export const gigSocialBoostsList = (params = '') => Http.get(`/admin/gigs/social-boosts${serialize(params)}`)
export const gigSocialBoostDecide = (id, data) => Http.post(`/admin/gigs/social-boosts/${id}/decide`, data)
export const gigSocialBoostPublished = (id, data) => Http.post(`/admin/gigs/social-boosts/${id}/published`, data)
